import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PendoService {
  private renderer: Renderer2;

  constructor(private rendererFactory: RendererFactory2) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  loadPendo(apiKey: string, currentUser: any): void {
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.text = `
      <!-- Pendo Analytics -->
      (function(apiKey){
        (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=o._q||[];
        v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
            o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
            y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
            z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo');
        pendo.initialize({
          visitor: {
            id: "${ currentUser.opsUserId ? ( currentUser.isProxyLogin ? 'Support_' + currentUser.opsUserId : currentUser.opsUserId) : ''}",
            userName: "${currentUser.userName ? currentUser.userName : ''}",
            userType: "${currentUser.pendo.userType ? currentUser.pendo.userType : ''}",
            titleCategory: "${currentUser.pendo.titleCategory ? currentUser.pendo.titleCategory : ''}",
            jobTitle: "${currentUser.pendo.jobTitle ? currentUser.pendo.jobTitle : ''}",
            assignedRoles: "${currentUser.pendo.assignedRoles ? currentUser.pendo.assignedRoles : ''}"
          },
           account: {
            id: "${currentUser.companyId ? currentUser.companyId : ''}",
            oecId:"${currentUser.pendo.oecId ? currentUser.pendo.oecId : ''}",
            accountName: "${currentUser.companyName ? currentUser.companyName.replace(/"/g, '') : ''}",
            msoType: "${currentUser.msoType ? currentUser.msoType : ''}",
            msoTypeName: "${currentUser.pendo.msoGroup ? currentUser.pendo.msoGroup : ''}",
            msoShopId: "${currentUser.pendo.msoShopId ? currentUser.pendo.msoShopId : ''}",
            supplierGroup: "${currentUser.pendo.supplierGroup ? currentUser.pendo.supplierGroup : ''}",
            market: "${currentUser.pendo.market ? currentUser.pendo.market : ''}",
            supplierRole: "${currentUser.pendo.supplierRole ? currentUser.pendo.supplierRole : ''}",
            packageName: "${currentUser.pendo.packageName ? currentUser.pendo.packageName : ''}",
            supplierDmsTypes: "${currentUser.pendo.supplierDmsTypes ? currentUser.pendo.supplierDmsTypes : ''}",
            makeTypes: "${currentUser.pendo.makeTypes ? currentUser.pendo.makeTypes : ''}",
            manufacturer: "${currentUser.pendo.manufacturer ? currentUser.pendo.manufacturer : ''}",
            estimateService: "${currentUser.pendo.estimateService ? currentUser.pendo.estimateService : ''}",
          }
        });
      })('${apiKey}');
    `;
    this.renderer.appendChild(document.body, script);
  }
}
